import { apiStudent } from '@/lib/api-manager'

export async function disapproveRequest(requestId?: string) {
  return await apiStudent.patch(`v1/requests/request/${requestId}/disapprove`)
}
